import { BaseCard } from "../../Components/Cards/BaseCard";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { IconInputCard } from "../../Components/Cards/IconInputCard";
import { useBoundStore } from "../../Store/store";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { parseStringToDateTimeWithDayjs } from "../../Utils/DateHelper";
import * as React from "react";
import PcSit from "../../Assets/images/illustrations/pc_sit.png";
import { STATUUT_STYLES } from "../../Utils/StatuutHelper";

export const MyApplications = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const applications = useBoundStore((state) => state.applications);
    const applicationsMetaData = useBoundStore((state) => state.applicationsMetaData);
    const user = useBoundStore((state) => state.user);

    const getAllApplicationsFromFreelancers = useBoundStore((state) => state.getAllApplicationsFromFreelancers);
    const isMultiStatuut = (user?.extra_statuten?.length ?? 0) > 0;

    const statuutBadge = (statuut) => {
        if (!isMultiStatuut || !statuut) return null;
        const info = STATUUT_STYLES[statuut];
        if (!info) return null;
        return <span className={`inline-block w-fit mt-1 px-2 py-0.5 rounded-full text-xs ${info.cls}`}>{info.label}</span>;
    };

    const [currentPage, setCurrentPage] = React.useState(1);

    useEffect(() => {
        getAllApplicationsFromFreelancers({page: currentPage, status: 'applied'}).then(r => {});
    }, [getAllApplicationsFromFreelancers, currentPage]);

    const goToNextPage = () => {
        if (canGoToNextPage()) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (canGoToPrevious()) {
            setCurrentPage((prevPage) => prevPage - 1);
        }
    };

    const getPageCountFromMetaData = () => {
        return applicationsMetaData?.last_page || 1;
    };

    const canGoToNextPage = () => {
        return applicationsMetaData?.current_page < applicationsMetaData?.last_page;
    };

    const canGoToPrevious = () => {
        return applicationsMetaData?.current_page > 1;
    };

    return (
        <div className="px-4 md:px-0">
            <BaseCard>
                {applications.length === 0 && (
                    <p className="text-sm text-gray-500 text-center py-8">{t('applications.no_applications')}</p>
                )}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {applications.map((application, index) => (
                        <IconInputCard
                            icon={faUser}
                            isImage={true}
                            otherImage={PcSit}
                            onClick={() => navigate(`/freelancer/applications/${application?.id}`)}
                            showArrow={true}
                            key={"my_applications_" + index}
                        >
                            <p className="text-sm md:text-lg flex flex-row gap-1 md:gap-2">
                                <span className="font-bold whitespace-nowrap">{t('applications.care_partner')}:</span>
                                <span className="truncate">{application?.shift?.branch?.company_name}</span>
                            </p>
                            <p className="text-sm md:text-sm flex flex-row gap-2">
                                <span className="font-bold">{t("general.fields.start_time")}:</span>
                                {parseStringToDateTimeWithDayjs(application?.shift?.start_time)}
                            </p>
                            <p className="text-sm md:text-sm flex flex-row gap-2">
                                <span className="font-bold">{t("general.fields.end_time")}:</span>
                                {parseStringToDateTimeWithDayjs(application?.shift?.end_time)}
                            </p>
                            {statuutBadge(application?.applied_as_statuut)}
                        </IconInputCard>
                    ))}
                </div>

                {applications.length > 0 && (
                <div className="flex sm:flex-row flex-col w-full mt-8 items-end justify-end gap-2 text-xs">
                    <div className="flex gap-2">
                        <button
                            className={`${
                                !canGoToPrevious()
                                    ? "bg-gray-100"
                                    : "hover:bg-gray-200 hover:cursor-pointer bg-gray-100"
                            } rounded p-1`}
                            onClick={() => setCurrentPage(1)}
                            disabled={!canGoToPrevious()}
                        >
                            <span className="w-5 h-5">{"<<"}</span>
                        </button>
                        <button
                            className={`${
                                !canGoToPrevious()
                                    ? "bg-gray-100"
                                    : "hover:bg-gray-200 hover:cursor-pointer bg-gray-100"
                            } rounded p-1`}
                            onClick={goToPreviousPage}
                            disabled={!canGoToPrevious()}
                        >
                            <span className="w-5 h-5">{"<"}</span>
                        </button>
                        <span className="flex items-center gap-1">
                            <input
                                min={1}
                                max={getPageCountFromMetaData()}
                                type="number"
                                value={currentPage}
                                onChange={(e) => {
                                    const pageLocal = e.target.value ? Number(e.target.value) : 1;
                                    setCurrentPage(pageLocal);
                                }}
                                className="border p-1 rounded w-10"
                            />
                            of {getPageCountFromMetaData()}
                        </span>
                        <button
                            className={`${
                                !canGoToNextPage()
                                    ? "bg-gray-100"
                                    : "hover:bg-gray-200 hover:cursor-pointer bg-gray-100"
                            } rounded p-1`}
                            onClick={goToNextPage}
                            disabled={!canGoToNextPage()}
                        >
                            <span className="w-5 h-5">{">"}</span>
                        </button>
                        <button
                            className={`${
                                !canGoToNextPage()
                                    ? "bg-gray-100"
                                    : "hover:bg-gray-200 hover:cursor-pointer bg-gray-100"
                            } rounded p-1`}
                            onClick={() => setCurrentPage(getPageCountFromMetaData())}
                            disabled={!canGoToNextPage()}
                        >
                            <span className="w-5 h-5">{">>"}</span>
                        </button>
                    </div>
                </div>
                )}
            </BaseCard>
        </div>
    );
};
